/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.CHECKBOX = function () {

    this.resourceKey = 'Survey.Sidebar.Checkbox';
    this.jsonType = 'CHECKBOX';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

    this.getPreviewContent = function (question) {
        var fieldSwitch     = new Monet.UI.Fields.Switch(),
            fieldSwitchRendered,
            switchContainer = document.createElement('div');

        fieldSwitchRendered = fieldSwitch.render();
        fieldSwitch.setCheckedLabel('Survey.CheckboxQuestion.checked');
        fieldSwitch.setUncheckedLabel('Survey.CheckboxQuestion.unchecked');
        fieldSwitch.setValue(question.defaultAnswer === 'true');

        switchContainer.id = question.id;
        switchContainer.appendChild(fieldSwitchRendered);

        return switchContainer;
    };

};